import { FC } from "react";
import { useTranslation } from "react-i18next";

import { GoToTariffOverviewTile } from "@/apps/partner/components/GoToTariffOverviewTile/GoToTariffOverviewTile";
import { AddDeviceTile } from "@/components/Portal/Cockpit/Tiles/AddDeviceTile/AddDeviceTile";

export const PartnerPortal: FC = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "cockpit.heading",
  });

  return (
    <div className="portal-content-wrapper">
      <h1 className="mb-10 text-secondary-100">{t("greeting")}</h1>
      <p className="mb-4 text-2xl">{t("description1")}</p>
      <p className="mb-20 max-w-2xl text-2xl">{t("description2")}</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-2 lg:flex lg:gap-8">
        <AddDeviceTile />
        <GoToTariffOverviewTile />
      </div>
    </div>
  );
};
